<template>
  <div class="partnership d-flex">
    <img
      class="partnership__image"
      :src="imgPrefix + data.image"
      alt="data.title"
    />

    <div class="py-12 pr-10 partnership__text">
      <bim-text type=main bold class="partnership__title mb-9">{{ data.title }}</bim-text>

      <bim-text type=medium v-html="data.text" />

      <bim-button
        class="mt-9"
        color=luxury
        label="Оставить заявку"
        @click="clickGetCall"
      />

      <div class="contacts mt-10" v-if="data.phone">
        <bim-text type=hint bold class="contacts__title">Контакты:</bim-text>

        <a :href="`tel:${data.phone}`" class="contacts__phone">{{ data.phone }}</a>

        <bim-text type=desc class="contacts__name mt-3">{{ data.contactName }}</bim-text>
      </div>
    </div>

    <bimPhoneRequest
      v-model="showPhonePopup"
      :userContext="user"
      @sended="onFormSended"
      :logActionEvent="logActionEvent"
      :sendFunction="handlerPhoneRequest"
    />
  </div>
</template>

<script>
import bimButton from '@/components/form/bimButton/bimButton'
import bimPhoneRequest from '@/components/ui/bimPhoneRequest/bimPhoneRequest'

export default {
  name: 'bimAffProgramm',
  components: {
    bimButton,
    bimPhoneRequest
  },
  props: {
    /**
     * Функция обрабатывающая запрос
     * номера телефона
     */
    handlerPhoneRequest: {
      type: Function,
      default: null
    },
    /**
     * Функция для отрправки логов
     */
    logActionEvent: {
      type: Function,
      default: () => {}
    },
    /**
     * Объект пользователя
     */
    user: {
      type: Object,
      required: true
    },
    /**
     * Объект партнерской программы
     */
    data: {
      type: Object,
      required: true
    },
    /**
     * Префикс для отображения картинки
     * (слеш в конце обязателен)
     */
    imgPrefix: {
      type: String,
      default: '/api/assets/images/'
    }
  },
  data () {
    return {
      showPhonePopup: false,
      isFormSended: false
    }
  },
  watch: {
    showPhonePopup (value) {
      if (!value && !this.isFormSended) {
        this.$logActionEvent('affProgramm not sended')
      }
    }
  },
  methods: {
    clickGetCall () {
      this.showPhonePopup = true
    },
    onFormSended () {
      this.isFormSended = true
      this.logActionEvent('get call affProgramm')
    }
  }
}
</script>

<style lang="scss" scoped>
.partnership {
  background-color: white;
  border-radius: 5px;

  @media screen and (max-width: $breakpoint-lg) {
    flex-flow: column;
  }

  .partnership__text {
    flex: 0 1 388px;

    @media screen and (max-width: $breakpoint-xl) {
      flex: 0 1 250px;
    }
  }

  .partnership__image {
    align-self: flex-start;
    flex-grow: 1;
    margin-right: 47px;
    margin-top: 30px;
    margin-bottom: 30px;
    object-fit: contain;
    width: 0px;
    max-width: 450px;
    max-height: 414px;
    object-fit: contain;

    @media screen and (max-width: $breakpoint-lg) {
      width: 100%;
      margin: auto;
    }
  }
}

.contacts {
  border: solid 1px #ededed;
  border-radius: 6px;
  padding: 14px;

  .contacts__title {
    text-transform: uppercase;
    opacity: .5;
    line-height: 2;
    letter-spacing: 1px;
  }

  .contacts__phone {
    font-size: 14px;
    text-decoration: none;
    color: inherit;
    line-height: 1.57;
    letter-spacing: 0.2px;
    border-bottom: dashed 1px $primary-color;
    padding-bottom: 2px;
  }

  .contacts__name {
    line-height: 1.83;
    letter-spacing: 0.5px;
  }
}
</style>
